import type { AuthContextType } from '@sov/common'
import { createContext } from 'react'

export const authContext = createContext<AuthContextType>(undefined)
